export const creditGroupOffersFragment = `
    id
    groupId
    offerId
    creditPrice
    validFrom
    validTo
    offer {
        id
        code
        name
        unit
    }
`;

export const creditGroupMembersFragment = `
    id
    groupId
    folderId
    validFrom
    validTo
    folder {
        id
        person {
            id
            titleBeforeName
            titleAfterName
            name
            surname
            birthdate
        }
    }
`;
